export default function shouldFireOnFocusBPTab(isFocused, setBPPhone, mobileNumber, userName) {
  if (isFocused) {
    setBPPhone({ mobileNumber, name: userName });
  }
}
